/**
 * @prettier
 * @flow
 */
import apisauce from 'apisauce';
import type { GetPaymentLinkRequest } from 'src/api/types/GetPaymentLinkRequest';
import type { GetPaymentLinkResponse } from 'src/api/types/GetPaymentLinkResponse';
import type { PayPaymentLinkRequest } from 'src/api/types/PayPaymentLinkRequest';
import type { PayPaymentLinkResponse } from 'src/api/types/PayPaymentLinkResponse';
import { appVersion } from 'src/config/appVersion';
import { environment } from 'src/config/environment';
import { Environment, type EnvironmentValue } from 'src/constants/Environment';
import { encryptDataInTransit } from 'src/utils/crypto/encryptDataInTransit';

function createPaymentLinkApi(environment: EnvironmentValue) {
    let baseURL;
    const params = {};
    console.log('environment = ', environment);
    switch (environment) {
        case Environment.LOCALHOST:
            baseURL = 'http://localhost:7071/api/paymentlinks';
            break;
        case Environment.TEST:
            baseURL = 'https://apipaymentlink-test.azurewebsites.net/api/paymentlinks';
            params.code = 'Jbvq1LNMSSRovjxONLP6I7k1Ojn/GKNP4C8irnLCG6DtZTZiFOl74Q==';
            break;
        case Environment.PROD:
            baseURL = 'https://apipaymentlink.azurewebsites.net/api/paymentlinks';
            params.code = 'MKzT9r4XvibA5G3HbC14dpvzCC9erFYLMxSc/FfoPySHoQbkGErIgQ==';
            break;
        default:
            throw new Error(`Invalid argument environment=${environment}`);
    }

    const api = apisauce.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
        },
        timeout: 60000, // 60 second timeout
    });

    if (process.env.NODE_ENV === 'development') {
        api.addRequestTransform(request => {
            const other = {};
            // if (request.headers) {
            //     other.headers = request.headers;
            // }
            if (request.params) {
                other.params = request.params;
            }
            if (request.data) {
                other.data = request.data;
            }
            console.log(`${request.method.toUpperCase()} ${baseURL}${request.url}`, other);
        });
        api.addMonitor(response => {
            console.log(`${response.status} <- ${response.config.url}`, response.data);
        });
    }

    api.addRequestTransform(request => {
        if (REQUEST_METHODS_WITH_PARAMS.includes(request.method)) {
            if (!request.params) request.params = {};
            request.params.appVersion = appVersion;
            request.params.code = params.code;
        } else {
            if (!request.data) request.data = {};
            if (!request.params) request.params = {};
            request.data.appVersion = appVersion;
            request.params.code = params.code;
        }
    });

    return {
        config: api,
        getPaymentLink: (request: GetPaymentLinkRequest): {| ...ApiSauceResponse, data: GetPaymentLinkResponse |} => api.post('/getPaymentLink', request),
        payPaymentLink: (request: PayPaymentLinkRequest): {| ...ApiSauceResponse, data: PayPaymentLinkResponse |} => api.post('/payPaymentLink', { encrypted: encryptDataInTransit(request) }),
    };
}

export const paymentLinkApi = createPaymentLinkApi(environment);

const REQUEST_METHODS_WITH_PARAMS = ['get', 'head', 'delete', 'link', 'unlink'];

type ApiSauceResponse = {|
    ok: boolean,
|};
